import styled from 'styled-components';

const ProfileStyle = styled.div`
    padding: 0 15px;
`;

export default ProfileStyle;
